import { useEffect, useState } from 'react';
export const useElementSize = (element) => {
    const [height, setHeight] = useState(null);
    const [width, setWidth] = useState(null);
    useEffect(() => {
        if (!element) {
            return;
        }
        const resizeObserver = new ResizeObserver(([entry]) => {
            const { height, width } = entry.target.getBoundingClientRect();
            setHeight(height);
            setWidth(width);
        });
        resizeObserver.observe(element);
        return () => resizeObserver.disconnect();
    });
    return { height, width };
};
